import React from 'react'
import PropTypes from 'prop-types'
import AccessibleTextLink from 'components/AccessibleTextLink'
import {
  Content,
  ModalSectionWrapper,
  HeaderWrapper,
  HeaderFourAndIconWrapper,
  StyledHeaderFour,
} from './component.styles'
import {
  IconMetric,
  IconPurpose,
  IconTarget,
  IconCalendar,
} from 'secondstep-components'
import {
  EDIT_TEXT,
  IMPLEMENTATION_APPROACH_LABEL_TEXT,
  PURPOSE_STATEMENT_LABEL_TEXT,
  GOALS_LABEL_TEXT,
  PROGRAM_START_DATE_LABEL_TEXT,
} from './constants'

const ModalSummarySection = ({ children, handleOpenEdit, sectionName }) => {
  let Icon = null
  switch (sectionName) {
    case IMPLEMENTATION_APPROACH_LABEL_TEXT:
      Icon = IconMetric
      break
    case PURPOSE_STATEMENT_LABEL_TEXT:
      Icon = IconPurpose
      break
    case GOALS_LABEL_TEXT:
      Icon = IconTarget
      break
    case PROGRAM_START_DATE_LABEL_TEXT:
      Icon = IconCalendar
      break
  }
  return (
    <ModalSectionWrapper>
      <HeaderWrapper>
        <HeaderFourAndIconWrapper>
          <Icon color="#3C6E90" fillColor="#eef0f2" />
          <StyledHeaderFour>{sectionName}</StyledHeaderFour>
        </HeaderFourAndIconWrapper>
        <AccessibleTextLink
          dataTestId={`edit-link-${sectionName}`}
          onClick={handleOpenEdit}
        >
          {EDIT_TEXT}
        </AccessibleTextLink>
      </HeaderWrapper>
      <Content>{children}</Content>
    </ModalSectionWrapper>
  )
}

ModalSummarySection.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  handleOpenEdit: PropTypes.func,
  sectionName: PropTypes.string,
}

export default ModalSummarySection
